export default __webpack_public_path__ + "static/media/dashboard-membergroup.0671c87a.svg";